"use client";

type ChartErrorProps = {
  error: string;
};

export function ChartError({ error }: ChartErrorProps) {
  const isRateLimit = error.toLowerCase().includes("too many requests");

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-[#16202d] rounded-lg z-10">
      {isRateLimit ? (
        <div className="text-center space-y-1">
          <p className="text-[#c7d5e0] text-sm font-medium">
            Too many requests
          </p>
          <p className="text-[#8f98a0] text-xs">
            Please wait a minute and try again.
          </p>
        </div>
      ) : (
        <p className="text-red-400 text-sm">Failed to load data: {error}</p>
      )}
    </div>
  );
}
